import { render } from "./ManageGoCardlessModal.vue?vue&type=template&id=24fccc75"
import script from "./ManageGoCardlessModal.vue?vue&type=script&lang=js"
export * from "./ManageGoCardlessModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__